(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // AUTO-HIDE: observa la direccion del scroll para ocultar al bajar y mostrar al subir.
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.dataset.homePersistent === 'true' ||
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.mobileMenu = this.querySelector('.reference-header__mobile-menu');

      if (this.mobileMenu) {
        this.mobileMenu.addEventListener('toggle', () => {
          this.header.classList.toggle('menu-open', this.mobileMenu.open);
        });
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
      this.querySelectorAll('mega-collections').forEach((menu) => menu.close());

      if (this.mobileMenu) this.mobileMenu.open = false;
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // MEGA MENU: hover en desktop, tap y cierre exterior en pantallas tactiles.
  class MegaCollections extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.mega-collections__trigger');
      this.panel = this.querySelector('.mega-collections__panel');
      this.isDesktopMenu = this.classList.contains('mega-collections--desktop');
      this.closeTimer = null;

      this.onTriggerClick = (event) => {
        event.preventDefault();
        this.toggle(!this.classList.contains('is-open'));
      };
      this.onPointerEnter = () => {
        if (!this.isDesktopMenu) return;
        window.clearTimeout(this.closeTimer);
        this.open();
      };
      this.onPointerLeave = () => {
        if (!this.isDesktopMenu) return;
        this.closeTimer = window.setTimeout(() => this.close(), 140);
      };
      this.onOutsideClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.onKeyDown = (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.trigger.focus();
        }
      };
      this.onOtherMenuOpen = (event) => {
        if (event.detail !== this) this.close();
      };
      this.onBlockSelect = (event) => {
        if (this.contains(event.target)) this.open();
      };

      this.trigger.addEventListener('click', this.onTriggerClick);
      this.addEventListener('pointerenter', this.onPointerEnter);
      this.addEventListener('pointerleave', this.onPointerLeave);
      document.addEventListener('click', this.onOutsideClick);
      document.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('mega-collections:open', this.onOtherMenuOpen);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.trigger.removeEventListener('click', this.onTriggerClick);
      this.removeEventListener('pointerenter', this.onPointerEnter);
      this.removeEventListener('pointerleave', this.onPointerLeave);
      document.removeEventListener('click', this.onOutsideClick);
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('mega-collections:open', this.onOtherMenuOpen);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    toggle(force) {
      force ? this.open() : this.close();
    }

    open() {
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.dispatchEvent(new CustomEvent('mega-collections:open', { detail: this }));
    }

    close() {
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('mega-collections', MegaCollections);

  } catch(e) { console.error(e); }
})();
})();
